import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../ts/services/RestApiService';


export type UngroupDatabasesRequestConfigParams = {
  readonly groupedDatabaseLuid: string;
  readonly copyMetadataToUngroupedItems: boolean;
}

export function getUngroupDatabasesRequestConfig(params: UngroupDatabasesRequestConfigParams): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.9',
    httpMethod: 'DELETE',
    endpoint: `databases/${params.groupedDatabaseLuid}/group?copyMetadataToUngroupedItems=${params.copyMetadataToUngroupedItems}`,
    serverWideRequest: false,
  };
}

export type UngroupDatabasesResponse = {
  readonly ungroupedDatabases: {
    readonly database: ReadonlyArray<{
      readonly id: string;
    }>;
  };
};

export function callViaApiService(params: UngroupDatabasesRequestConfigParams) {
  return makeJsonRestApiRequest<void, UngroupDatabasesResponse>({
    config: getUngroupDatabasesRequestConfig(params),
    request: null,
  });
}
